import { PermissionDto } from '@/api/generated';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

/** True when the signed-in user holds the permission (through their role or an additional grant). */
export const useHasPermission = (permission: PermissionDto): boolean => {
  const { permissions } = useUserContext();
  return permissions.includes(permission);
};
